import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-bottom">
      {/* Bottom Section */}
      <div className="footer-bottom-content container">
        <p>© All Rights Reserved</p>
        <ul className="footer-links">
          <li>
            <a href="https://www.sebi.gov.in/" target="_blank" rel="noopener noreferrer">
              SEBI
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://www.rbi.org.in/" target="_blank" rel="noopener noreferrer">
              RBI
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://www.bseindia.com/" target="_blank" rel="noopener noreferrer">
              BSE
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://www.nseindia.com/" target="_blank" rel="noopener noreferrer">
              NSE
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://www.cdslindia.com/" target="_blank" rel="noopener noreferrer">
              CDSL
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://www.amfiindia.com/" target="_blank" rel="noopener noreferrer">
              AMFI
            </a>
          </li>
          <span>|</span>
          <li>
            <a href="https://investor.sebi.gov.in/" target="_blank" rel="noopener noreferrer">
              Investor Awareness
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
